export default __webpack_public_path__ + "static/media/dance.e666f0ae.gif";